<template>
    <el-dialog title="Supprimer du PIM" v-loading="loader" :visible.sync="display" width="50%">
        <span>Restaurer les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formRestorePim" ref="form" :model="form">
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Restaurer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';

export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                mode: 'restore_pim',
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Restaurer les produits du PIM) ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios
                    .post('/products/bulk', datas)
                    .then(r => {
                        EventBus.$emit('products.list.refresh')
                        this.display = false;
                    })
                    .catch(() => {

                    })
                    .then(() => {
                        this.loader = false;
                    });
            }).catch(()=>{
                this.display = false;
                this.loader = false;
            })

        }
    }
};
</script>
